module.exports = __webpack_public_path__ + "img/440-e1777b.png";